var pre = new nc.promokit.Preloader({
    'game': 'lineage2',
    'video': [
        'https://vod.plaync.com/lineage2/update/1105/Field_1.mp4',
        'https://vod.plaync.com/lineage2/update/1105/Field_2.mp4',
    ],
});

/*
if(document.cookie == ''){
    location.reload();
    console.log('reload');
}
*/
// console.log(pre)

/*
if(pre.store.progress !== 0){
    location.reload();
    console.log('reload');
}
*/

$(document).on('preloadend', function(){
    var olympiad = (function () {
        function Base() {
            this.players = {};
            this.init();
        }
        Base.prototype = {
            init:function () {
                this.setPlayer();
                this.hover();
            },
            setPlayer:function() {
                this.players.field = new nc.promokit.Player({
                    selector: '#player-field',
                    videoId:'https://vod.plaync.com/lineage2/update/1105/Field_1.mp4',
                    mute: true,
                    loop: true
                });
                this.players.buff = new nc.promokit.Player({
                    selector: '#player-buff',
                    videoId:'https://vod.plaync.com/lineage2/update/1105/Field_2.mp4',
                    mute: true,
                    loop: true
                });
            },
            hover:function () {
                var _this = this;
                var promise_field;
                var promise_buff;
                var $field = $('.player-list__item-field');
                var $buff = $('.player-list__item-buff');
                $field.on('mouseover',function () {
                    promise_field = _this.players.field.play();
                });
                $buff.on('mouseover',function () {
                    promise_buff = _this.players.buff.play();
                });
                $field.on('mouseleave',function () {
                    if(promise_field !== undefined){
                        promise_field.then(_ => {
                            _this.players.field.pause();
                        }).catch(error => {
                            _this.players.field.play();
                        });}
                    else {
                        _this.players.field.pause();
                    }
                });
                $buff.on('mouseleave',function () {
                    if(promise_buff !== undefined){
                        promise_buff.then(_ => {
                            _this.players.buff.pause();
                        }).catch(error => {
                            _this.players.buff.play();
                        });}
                    else {
                        _this.players.buff.pause();
                    }
                });
            }
        };
        return Base;
    })();
    window.olympiad = new olympiad();

/*
    var cookies = document.cookie.split(";");
    if(cookies.length <= 1) {
        console.log('reload');
        window.location.reload(true);
    }
    else if(!cookies[2].includes(' _gat_UA-')) {
        window.location.reload(true);
    } else if(!cookies[2].includes(' _gat_UA-'))
*/
    setTimeout(function () {
        if($('.loader')[0]){
            console.log('reload');
            window.location.reload(true);
        }
    }, 800);
});

var Ptab = function(el) {
    var $el = $(el);
    $el.on('click','.p-tab-list__item', function () {
        var $tab_list = $('.p-tab');
        $tab_list.attr('class','p-tab');
        $tab_list.addClass('p-tab--' + this.getAttribute('data-tab'));
    });
};

$(document).ready(function () {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});

    new nc.promokit.remote({
        element:"#remoteMenu",
        margin:-100,
        top:920,
        fix:287,
        show:true,
        quick:true,
        cspeed:600
    });

    new Ptab("#how-apply");
});



// WEBPACK FOOTER //
// ./src/js/olympiad.js